

import CryptoJS from 'crypto-js'
let canvasFingerprint: string = ''
const generateEncrypted = (text: string, secretKey = 'cheat_warning_110') => {
  const encrypted = CryptoJS.AES.encrypt(text, secretKey, {
    keySize: 256
  })
  return encrypted
}

const createCanvas = (): HTMLCanvasElement => {
  const canvas = document.createElement("canvas");
  canvas.width = 100
  canvas.height = 60
  const ctx: CanvasRenderingContext2D = canvas.getContext("2d") as CanvasRenderingContext2D;
  ctx.fillStyle = '#f0f0f0';
  ctx.fillRect(0, 0, canvas.width, canvas.height);

  // 中心圆
  ctx.fillStyle = '#8B4513'; // 棕色
  ctx.beginPath();
  ctx.arc(50, 50, 50, 0, Math.PI * 2);
  ctx.fill();

  // 四个角的圆
  const cornerRadius = 30;
  ctx.fillStyle = '#6F4C3E'; // 深棕色
  ctx.beginPath();
  ctx.arc(40, 40, cornerRadius, 0, Math.PI * 2); // 左上角
  ctx.fill();

  ctx.beginPath();
  ctx.arc(60, 40, cornerRadius, 0, Math.PI * 2); // 右上角
  ctx.fill();

  ctx.beginPath();
  ctx.arc(40, 60, cornerRadius, 0, Math.PI * 2); // 左下角
  ctx.fill();

  ctx.beginPath();
  ctx.arc(60, 60, cornerRadius, 0, Math.PI * 2); // 右下角
  ctx.fill();

  // 中间的十字
  ctx.fillStyle = '#FFD700'; // 金色
  ctx.fillRect(45, 0, 10, 300); // 垂直线
  ctx.fillRect(0, 45, 300, 10); // 水平线

  ctx.fillText("xi🌶ao啊ika😁99", 30, 30);
  return canvas
}


const generateCanvasFingerprint = async () => {
  if (!document) return ''
  if (canvasFingerprint) return canvasFingerprint
  const startTime = performance.now()
  const canvas = createCanvas()
  // 获取图像数据
  const dataURL = canvas.toDataURL();
  const userAgent = window.navigator.userAgent
  const hash = CryptoJS.SHA256(`${dataURL}${userAgent}`).toString(CryptoJS.enc.Hex)
  canvasFingerprint = hash
  const endTime = performance.now()
  const generateTime = endTime - startTime
  localStorage.setItem('generateFingerprintTime', `${generateTime}ms`)
  return hash
}

export const generateFingerprint = async () => {
  const canvasFingerprint = await generateCanvasFingerprint()
  const text = [canvasFingerprint, Date.now()].join('_')
  const encrypted = generateEncrypted(text)
  return encrypted
}

export const setupInterceptors = (instance:any) => {
  instance.interceptors.request.use(async (config:any) => {
    if (!config.headers) config.headers = {};
    try {
      const fingerprint = await generateFingerprint()
      if (fingerprint) {
        config.headers.bs = fingerprint;
      }
    } catch (error) {
    }

    return config
  }, (error:any) => Promise.reject(error));
  instance.interceptors.response.use((response:any) => response, (error: any) => {
    if (error?.response?.status === 402) {
      const errorCode: string[] = ["L25", "L26"]
      if (errorCode.includes(error?.response?.data?.errorCode)) {
        window.location.href = `/deviceRepeat?errorCode=${error?.response?.data?.errorCode}`
        return
      }
    }
    return Promise.reject(error);
  });

}